<template>
  <!--
    persistent: the broadcast pop-up is rendered as a sibling overlay, and
    because this dialog has no scrim Vuetify treats any click inside that
    pop-up as a click outside of this one. Stay open; the X button closes.
    no-click-animation: skip the "bounce" a persistent dialog plays on an
    outside click, which here would fire on every pop-up interaction.
  -->
  <v-dialog
    :model-value="dialog"
    @update:modelValue="onDialogUpdate"
    fullscreen
    :scrim="false"
    persistent
    no-click-animation
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card>
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title class="font-weight-bold">
          My Messages
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text class="mt-5">
        <MessageCenterMessagesList />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script lang="ts" setup>
import MessageCenterMessagesList from '@/Core.Service.Domain/MessageCenter/Users/Components/MessageCenterMessagesList.vue';

import { useRouter } from 'vue-router';

defineProps(['dialog']);
const emits = defineEmits(['closeDialog']);

const router = useRouter();
const closeDialog = () => {
  emits('closeDialog');
  router.push({ name: 'Portfolio' });
};

// Vuetify can still deactivate the dialog on its own (e.g. browser Back with
// close-on-back). Without a listener the dialog runs uncontrolled and the
// parent's flag stays true, so the next "Messages" click is a no-op until a
// reload (sc-22735). Mirror every internal close back through closeDialog.
const onDialogUpdate = (isOpen: boolean) => {
  if (!isOpen) {
    closeDialog();
  }
};
</script>
<script lang="ts">
export default {
  name: 'MessageCenterDialog',
};
</script>
